module.exports = __webpack_public_path__ + "media/szamar_m.c81ee337.mp3";